import axiosPublicClient from "../../../../axiosPublicClient"

export default async (data) => {

    const result = await axiosPublicClient.post(`/retrieve-candidate-results`, data)

    return result.data

}
